import { Theme } from '@mui/material';

const useStyles = (theme: Theme) => ({
  gridContainer: {
    px: '16px',
  },
  container: {
    display: 'flex',
    padding: '16px',
    alignItems: 'center',
    gap: '4px',
  },
  groupRadioContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '8px',
  },
  wrapper: {
    display: 'flex',
    width: '100%',
    padding: '12px',
    alignItems: 'flex-start',
    alignContent: 'space-between',
    gap: '4px',
    alignSelf: 'stretch',
    borderRadius: '4px',
    border: `1px solid ${theme.palette.grey[100]}`,
    background: theme.palette.secondary.main,
    flexWrap: 'wrap',
  },
});

export default useStyles;
